<mat-card class="dialog-card">
  <mat-card-title class="dialog-card-header">
    <mat-toolbar class="dialog-toolbar" color="accent" fxLayout="row" fxLayoutAlign="space-between center">
      <h1 class="dialog-card-title">{{ 'USERS.PROFILE_INFO_FORM.UI.POPUP_TITLE' | translate }}</h1>
      <button (click)="close()" class="regular-round-button" mat-icon-button>
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar>
  </mat-card-title>
  <mat-card-content class="dialog-card-content p-4" fxLayout="row" fxLayoutGap="20px">
    <form [formGroup]="form" fxFlex fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">
      <mat-form-field class="" color="accent" fxFlex>
        <mat-label>{{ 'USERS.PROFILE_PREFERENCES.LANGUAGE' | translate }}</mat-label>
        <mat-select formControlName="appLanguage" required>
          @for (language of availableLanguages; track language) {
            <mat-option [value]="language">
              {{ 'USERS.PROFILE_PREFERENCES.LANGUAGES.' + language | translate }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field color="accent" fxFlex>
        <mat-label>{{ 'IOT_DICTIONARY.COUNTRY' | translate }}</mat-label>
        <mat-select formControlName="addressCountry">
          @for (country of countries$ | async; track country.key) {
            <mat-option [value]="country.key">{{ country.value }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </form>
  </mat-card-content>
  <mat-card-actions class="dialog-card-actions" fxLayout="row" fxLayoutAlign="end center">
    <button (click)="close()" class="button-regular" mat-button>{{ 'USERS.PROFILE_INFO_FORM.UI.BUTTONS.CANCEL' | translate }}</button>
    <button (click)="save()" [disabled]="!form.valid" class="button-regular" color="accent" mat-raised-button>
      {{ 'USERS.PROFILE_INFO_FORM.UI.BUTTONS.SAVE' | translate }}
    </button>
  </mat-card-actions>
</mat-card>
